import { NgModule } from '@angular/core';
import { LetterGlitchBackgroundComponent } from './letter-glitch-background.component';
import { CommonModule } from '@angular/common';

@NgModule({
    declarations: [
        LetterGlitchBackgroundComponent
    ],
    imports: [
        CommonModule
    ],
    exports: [
        LetterGlitchBackgroundComponent
    ]
})
export class NcLetterGlitchBackgroundModule { }